import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { Alert, PageHeader } from '../../components/ui';
import { useI18n } from '../../i18n';
import { useSyndicate } from '../../session';

export function MaintenanceNav() {
  const { t } = useI18n();
  const base = `${useSyndicate().base}/maintenance`;
  const m = t.maintenance.nav;
  return (
    <nav className="subnav" aria-label={t.maintenance.title}>
      <NavLink to={base} end>
        {m.workOrders}
      </NavLink>
      <NavLink to={`${base}/calendar`}>{m.calendar}</NavLink>
      <NavLink to={`${base}/logbook`}>{m.logbook}</NavLink>
      <NavLink to={`${base}/assets`}>{m.assets}</NavLink>
      <NavLink to={`${base}/vendors`}>{m.vendors}</NavLink>
    </nav>
  );
}

/** Common frame of the maintenance pages: title, sub-navigation, board-only access. */
export function MaintenanceFrame({ intro, actions, children }: { intro?: string; actions?: ReactNode; children: ReactNode }) {
  const { t } = useI18n();
  const s = useSyndicate();
  if (!s.can('maintenance.read')) {
    return (
      <>
        <PageHeader title={t.maintenance.title} />
        <Alert tone="info">{t.maintenance.boardOnly}</Alert>
      </>
    );
  }
  return (
    <>
      <PageHeader title={t.maintenance.title} intro={intro} actions={actions} />
      <MaintenanceNav />
      {children}
    </>
  );
}

/** Dollars typed by a person → cents; '' → undefined; invalid → NaN (rejected by the contract). */
export function centsOf(input: string): number | undefined {
  const normalized = input.replace(/[\s $]/g, '').replace(',', '.');
  if (normalized === '') return undefined;
  return /^\d+(\.\d{1,2})?$/.test(normalized) ? Math.round(Number(normalized) * 100) : Number.NaN;
}

export const dollars = (cents: number | null | undefined) => (cents == null ? '' : (cents / 100).toFixed(2));
export const todayIso = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto' }).format(new Date());
